// extracted by mini-css-extract-plugin
module.exports = {"responsibleGaming":"_e8e8869","regulatoryText":"_bb64f3d","regulatoryIconText":"_4412106"};